import React from 'react';
import PropTypes from 'prop-types';
import metrics from '../../browser/metrics';
import { useScript } from '../hooks/useScript';

const scriptAttributes = {
  async: true,
  type: 'text/javascript',
  src: '//cdn2.auth0.com/js/m/metrics-1.min.js',
  onload: () => { 
    metrics.init();
  }
};

const REQUIRED_CONSENT_LEVEL = 2;

export const useMetrics = consentLevel => {
  const hasConsent = consentLevel >= REQUIRED_CONSENT_LEVEL;
  useScript('head', scriptAttributes, hasConsent);
};

export const Metrics = ({ consentLevel }) => {
  useMetrics(consentLevel);
  return null;
};

Metrics.propTypes = {
  consentLevel: PropTypes.number
};
